module.exports = __webpack_public_path__ + "img/original-water.909c0780.svg";